import { api } from '@/lib/api';
import { queryOptions } from '@tanstack/react-query';
import { queryKeys } from '../queryKeys';
import type { InvitationResponse } from './invitationMutations';

export interface InvitationsFilters {
  search?: string;
  email?: string;
}

export interface InvitationsResponse {
  data: Array<InvitationResponse>;
  meta?: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

const appendInvitationFilters = (
  searchParams: URLSearchParams,
  filters?: InvitationsFilters,
) => {
  if (filters?.search) {
    searchParams.set('search', filters.search);
  }
  if (filters?.email) {
    searchParams.set('email', filters.email);
  }
};

export const getInvitationsQuery = (
  role?: 'Doctor' | 'Customer',
  page: number = 1,
  filters?: InvitationsFilters,
) => {
  return queryOptions({
    queryKey: [...queryKeys.invitations.all(role), page, filters],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.set('page', String(page));
      if (role) {
        searchParams.set('role', role);
      }
      appendInvitationFilters(searchParams, filters);
      return await api
        .get('admin/invitations', { searchParams })
        .json<InvitationsResponse>();
    },
  });
};

export const getInvitationsAsDoctorQuery = (
  page: number = 1,
  filters?: InvitationsFilters,
) => {
  return queryOptions({
    queryKey: [...queryKeys.invitations.all(), 'doctor', page, filters],
    queryFn: async () => {
      const searchParams = new URLSearchParams();
      searchParams.set('page', String(page));
      appendInvitationFilters(searchParams, filters);
      return await api
        .get('invitations', { searchParams })
        .json<InvitationsResponse>();
    },
  });
};

export const getInvitationByUuidQuery = (uuid: string) => {
  return queryOptions({
    queryKey: queryKeys.invitations.detail(uuid),
    queryFn: async () => {
      return await api
        .get(`invitations/${uuid}`)
        .json<{ data: InvitationResponse }>();
    },
    retry: false,
  });
};
